var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutDesignVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 244,
    viewBox: "0 0 477 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.479 214H313V215.533H336.805L357.017 235.679H401.708L410.242 244H449.093L472 221.664L470.877 220.569L448.42 242.467H410.915L402.381 234.146H357.691L337.479 214Z",
    fill: "url(#paint0_linear_4_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470 184H429.191L400.491 212.444H371.118L343.763 185.333H249.365L227.167 207.333H196V208.667H227.84L250.038 186.889H343.314L370.445 214H400.939L429.864 185.556H470V184Z",
    fill: "url(#paint1_linear_4_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.694 164H187.07L175.773 174.906H129V176.433H176.451L187.748 165.527H251.016L289.88 203.044H349.306L376.195 229H447.823L460.024 217.44H472V215.913H459.346L447.371 227.473H376.873L349.758 201.517H290.558L251.694 164Z",
    fill: "url(#paint2_linear_4_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M386 77H359.878L333.086 103.065H299.149L223.685 176.48H196V178H224.355L299.819 104.585H333.756L360.548 78.5205H386V77Z",
    fill: "url(#paint3_linear_4_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M419.547 158H381.277L365.969 172.96H282V176.04H367.32L382.628 161.08H418.422L438.007 180H472V177.14H439.133L419.547 158Z",
    fill: "url(#paint4_linear_4_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.011 103H358.866L296.165 159.877H255.753L225.872 132.665H127.412L110.513 117.275H87V120.398H109.288L125.943 135.565H224.402L254.528 163H297.635L360.09 105.9H386.787L400.013 118.167H473V115.268L401.482 115.045L388.011 103Z",
    fill: "url(#paint5_linear_4_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.39 110H262.245L216.607 154.889H164V158H217.956L263.369 112.889H360.041L381.399 134H472V130.889H382.523L361.39 110Z",
    fill: "url(#paint6_linear_4_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.872 101H87L87.3058 102.519H131.955L162.537 124H250V122.481H163.148L132.872 101Z",
    fill: "url(#paint7_linear_4_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449.553 40H334.138L301.516 71.8432H242.571L219.398 94.4628H196V96H220.073L243.246 73.3804H302.191L334.813 41.3176H449.103L469.801 61.5216H477V59.9843H470.251L449.553 40Z",
    fill: "url(#paint8_linear_4_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M430.941 0H333.389L323.251 9.90248H270.306L201.141 77.4596H108.095L94.1265 63.8161L93 64.9164L107.419 79H201.817L270.982 11.4429H323.926L334.065 1.54038H430.265L437.7 9.02229H476V7.4819H438.376L430.941 0Z",
    fill: "url(#paint9_linear_4_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.231 64H176V65.3099H255.553L284.933 93.6902H390.249L423.472 126H475V124.472H424.15L390.701 92.3803H285.611L256.231 64Z",
    fill: "url(#paint10_linear_4_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M315 214C315 212.385 313.846 211 312.5 211C311.154 211 310 212.385 310 214C310 215.615 311.154 217 312.5 217C313.846 217 315 215.615 315 214Z",
    fill: "url(#paint11_linear_4_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.982 206.5C196.982 204.962 195.832 204 194.491 204C193.15 204 192 205.154 192 206.5C192 207.846 193.15 209 194.491 209C195.832 209 197.173 207.846 196.982 206.5Z",
    fill: "url(#paint12_linear_4_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199 175.989C199 174.38 197.615 173 196 173C194.385 173 193 174.38 193 175.989C193 177.598 194.385 179.208 196 178.978C197.615 178.978 199 177.598 199 175.989Z",
    fill: "url(#paint13_linear_4_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199 95C199 93.1539 197.615 92 196 92C194.385 92 193 93.3846 193 95C193 96.6154 194.385 98 196 98C197.615 98 199 96.6154 199 95Z",
    fill: "url(#paint14_linear_4_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M338 42.2308C338 40.6154 336.615 39.2308 335 39C333.385 39 332 40.3846 332 42C332 43.6154 333.385 45 335 45C336.615 45 338 43.6154 338 42V42.2308Z",
    fill: "url(#paint15_linear_4_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96 64C96 62.3846 94.6154 61 93 61C91.3846 61 90 62.3846 90 64C90 65.6154 91.3846 67 93 67C94.6154 67 96 65.6154 96 64Z",
    fill: "url(#paint16_linear_4_2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179 63.8889C179 62.3333 177.846 61 176.5 61C175.154 61 174 62.3333 174 63.8889C174 65.4444 175.154 67 176.5 67C177.846 67 179 65.6667 179 64.1111V63.8889Z",
    fill: "url(#paint17_linear_4_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M388 77.011C388 75.4016 386.615 73.7921 385 74.022C383.385 74.022 382 75.4016 382 77.011C382 78.6205 383.385 80 385 80C386.615 80 388 78.6205 388 77.011Z",
    fill: "url(#paint18_linear_4_2)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M403 211.989C403 210.38 401.667 209 399.889 209C398.111 209 397 210.38 397 211.989C397 213.598 398.333 215.208 399.889 214.978C401.444 214.978 402.778 213.598 402.778 211.989H403Z",
    fill: "url(#paint19_linear_4_2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134 175.593C134 174.296 132.615 173.185 131 173C129.385 173 128 174.111 128 175.593C128 177.074 129.385 178 131 178C132.615 178 134 176.889 134 175.593Z",
    fill: "url(#paint20_linear_4_2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167 156C167 153.684 165.316 152 163 152C160.684 152 159 153.684 159 156C159 158.316 160.895 160 163 160C165.105 160 167 158.316 167 156Z",
    fill: "url(#paint21_linear_4_2)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286 174C286 171.684 284.316 170 282 170C279.684 170 278 171.684 278 174C278 176.316 279.684 178 282 178C284.105 178 286 176.316 286 174Z",
    fill: "url(#paint22_linear_4_2)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M371 174C371 171.895 368.895 170 366 170C363.105 170 361 171.684 361 174C361 176.316 363.105 178 366 178C368.895 178 371 176.105 371 174Z",
    fill: "url(#paint23_linear_4_2)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305 215C305 218.719 308.281 222 312.5 222C316.719 222 320 218.938 320 215C320 211.062 316.719 208 312.5 208C308.281 208 305 211.062 305 215ZM306.172 215C306.172 211.937 308.984 209.312 312.266 209.312C315.547 209.312 318.359 211.937 318.359 215C318.359 218.063 315.547 220.688 312.266 220.688C308.984 220.688 306.172 218.063 306.172 215Z",
    fill: "url(#paint24_linear_4_2)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M394 212C394 215.719 397.062 219 401 219C404.937 219 408 215.938 408 212C408 208.062 404.937 205 401 205C397.281 205 394 208.062 394 212ZM395.094 212C395.094 208.937 397.719 206.312 400.781 206.312C403.844 206.312 406.469 208.937 406.469 212C406.469 215.063 403.844 217.688 400.781 217.688C397.719 217.688 395.094 215.063 395.094 212Z",
    fill: "url(#paint25_linear_4_2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187 207.5C187 210.953 190.5 214 195 214C199.5 214 203 211.156 203 207.5C203 203.844 199.5 201 195 201C190.75 201 187 203.844 187 207.5ZM188.25 207.5C188.25 204.453 191.25 202.219 194.75 202.219C198.25 202.219 201.25 204.656 201.25 207.5C201.25 210.344 198.25 212.781 194.75 212.781C191.25 212.781 188.25 210.344 188.25 207.5Z",
    fill: "url(#paint26_linear_4_2)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378 78C378 81.7187 381.062 85 385 85C388.938 85 392 81.9375 392 78C392 74.2812 388.938 71 385 71C381.062 71 378 74.0625 378 78ZM379.313 78C379.313 74.9375 381.937 72.3125 385 72.3125C388.063 72.3125 390.688 74.9375 390.688 78C390.688 81.0625 388.063 83.6875 385 83.6875C381.937 83.6875 379.313 81.0625 379.313 78Z",
    fill: "url(#paint27_linear_4_2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M327 41C327 44.7187 330.063 48 334 48C337.938 48 341 44.9375 341 41C341 37.2812 337.938 34 334 34C330.063 34 327 37.0625 327 41ZM328.094 41C328.094 37.9375 330.719 35.3125 333.781 35.3125C336.844 35.3125 339.469 37.9375 339.469 41C339.469 44.0625 336.844 46.6875 333.781 46.6875C330.719 46.6875 328.094 44.0625 328.094 41Z",
    fill: "url(#paint28_linear_4_2)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189 95.5C189 98.9531 192.062 102 196 102C199.719 102 203 99.1563 203 95.5C203 91.8437 199.938 89 196 89C192.062 89 189 91.8437 189 95.5ZM190.313 95.5C190.313 92.6562 192.937 90.2187 196 90.2187C199.063 90.2187 201.688 92.6562 201.688 95.5C201.688 98.3438 199.063 100.781 196 100.781C192.937 100.781 190.313 98.3438 190.313 95.5Z",
    fill: "url(#paint29_linear_4_2)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65C85 68.7187 88.0625 72 92 72C95.9375 72 99 68.9375 99 65C99 61.0625 95.9375 58 92 58C88.0625 58 85 61.0625 85 65ZM86.0937 65C86.0937 61.9375 88.7188 59.3125 91.7813 59.3125C94.8438 59.3125 97.4688 61.9375 97.4688 65C97.4688 68.0625 94.8438 70.6875 91.7813 70.6875C88.7188 70.6875 86.0937 68.0625 86.0937 65Z",
    fill: "url(#paint30_linear_4_2)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168 63.5C168 67.4844 171.281 71 175.5 71C179.719 71 183 67.7188 183 63.5C183 59.2812 179.719 56 175.5 56C171.516 56 168 59.2812 168 63.5ZM169.406 63.5C169.406 60.2187 172.219 57.4062 175.5 57.4062C178.781 57.4062 181.594 60.2187 181.594 63.5C181.594 66.7813 178.781 69.5938 175.5 69.5938C172.219 69.5938 169.406 66.7813 169.406 63.5Z",
    fill: "url(#paint31_linear_4_2)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M124 176C124 179.333 126.667 182 130 182C133.333 182 136 179.333 136 176C136 172.667 133.333 170 130 170C126.667 170 124 172.667 124 176ZM125.111 176C125.111 173.333 127.333 171.111 130 171.111C132.667 171.111 134.889 173.333 134.889 176C134.889 178.667 132.667 180.889 130 180.889C127.333 180.889 125.111 178.667 125.111 176Z",
    fill: "url(#paint32_linear_4_2)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M190 177C190 180.333 192.667 183 196 183C199.333 183 202 180.333 202 177C202 173.667 199.333 171 196 171C192.667 171 190 173.667 190 177ZM191.111 177C191.111 174.333 193.333 172.111 196 172.111C198.667 172.111 200.889 174.333 200.889 177C200.889 179.667 198.667 181.889 196 181.889C193.333 181.889 191.111 179.667 191.111 177Z",
    fill: "url(#paint33_linear_4_2)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M358 173.5C358 178.802 362.198 183 367.5 183C372.802 183 377 178.802 377 173.5C377 168.198 372.802 164 367.5 164C362.419 164 358.221 168.198 358.221 173.279L358 173.5ZM359.547 173.5C359.547 169.302 363.081 165.767 367.279 165.767C371.477 165.767 375.012 169.302 375.012 173.5C375.012 177.698 371.477 181.233 367.279 181.233C363.081 181.233 359.547 177.698 359.547 173.5Z",
    fill: "url(#paint34_linear_4_2)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272 173.5C272 178.802 276.419 183 282 183C287.581 183 292 178.802 292 173.5C292 168.198 287.581 164 282 164C276.419 164 272.233 168.198 272.233 173.279L272 173.5ZM273.628 173.5C273.628 169.302 277.349 165.767 281.767 165.767C286.186 165.767 289.907 169.302 289.907 173.5C289.907 177.698 286.186 181.233 281.767 181.233C277.349 181.233 273.628 177.698 273.628 173.5Z",
    fill: "url(#paint35_linear_4_2)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M153.008 156C153.008 161.349 157.254 166 162.393 166C167.531 166 172 161.581 172 156C172 150.419 167.755 146 162.393 146C157.03 146 152.785 150.419 153.008 156ZM154.572 156C154.572 151.581 158.147 147.861 162.393 147.861C166.638 147.861 170.213 151.581 170.213 156C170.213 160.419 166.638 164.14 162.393 164.14C158.147 164.14 154.572 160.419 154.572 156Z",
    fill: "url(#paint36_linear_4_2)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64156 126.263L79.0028 126.263C81.0143 126.263 82.645 124.635 82.645 122.627V100.086C82.645 98.0778 81.0143 96.4499 79.0028 96.4499L9.64156 96.4499C7.63002 96.4499 5.99932 98.0778 5.99932 100.086V122.627C5.99932 124.635 7.63002 126.263 9.64156 126.263Z",
    fill: "#CCFFFD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27547 130.799H79.5374C83.5556 130.799 86.813 127.547 86.813 123.535V98.2634C86.813 94.252 83.5556 91 79.5374 91H8.27547C4.25726 91 0.999863 94.252 0.999863 98.2634V123.535C0.999863 127.547 4.25726 130.799 8.27547 130.799Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M230.895 90.5083H247.523V73.9073H230.895V90.5083Z",
    fill: "#CCFFFD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M230.895 69.4417H247.523V61.1413H230.895V69.4417Z",
    fill: "#CCFFFD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211 77.6009H227.629V61H211V77.6009Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M283 119.224H288.786V104H283V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M292.512 119.224H298.298V104H292.512V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.02 119.224H307.806V104H302.02V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M311.532 119.224H317.318V104H311.532V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M321.045 119.224H326.831V104H321.045V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M330.552 119.224H336.338V104H330.552V119.224Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M360.987 134H349V145.967H360.987V134Z",
    fill: "#CCFFFD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M360.93 149.674H349V153.893H360.93V149.674Z",
    fill: "#CCFFFD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M449.134 13H357V33.7975H449.134V13Z",
    stroke: "#CCFFFD",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2",
    x1: 7.57626,
    y1: 229.109,
    x2: 726.22,
    y2: 229.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_2",
    x1: 7.87725,
    y1: 198.889,
    x2: 725.39,
    y2: 198.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_2",
    x1: 4.72464,
    y1: 196.5,
    x2: 727.781,
    y2: 196.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_2",
    x1: 8.23268,
    y1: 127.391,
    x2: 722.686,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_2",
    x1: 6.45497,
    y1: 169,
    x2: 726.834,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_2",
    x1: -35.7069,
    y1: 132.888,
    x2: 748.049,
    y2: 132.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_2",
    x1: 7.07737,
    y1: 134,
    x2: 726.493,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_2",
    x1: -65.9081,
    y1: 112.5,
    x2: 912.704,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_2",
    x1: 6.34186,
    y1: 67.8902,
    x2: 726.278,
    y2: 67.8902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_2",
    x1: 6.03647,
    y1: 39.61,
    x2: 726.978,
    y2: 39.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_2",
    x1: 5.14285,
    y1: 95,
    x2: 728.348,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_2",
    x1: 50.7692,
    y1: 214,
    x2: 665.962,
    y2: 214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_2",
    x1: 33.737,
    y1: 206.5,
    x2: 646.671,
    y2: 206.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_2",
    x1: 1.23077,
    y1: 175.989,
    x2: 739.462,
    y2: 175.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_2",
    x1: 0.76921,
    y1: 95,
    x2: 739,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_2",
    x1: -1.69233,
    y1: 42.2308,
    x2: 736.538,
    y2: 42.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_2",
    x1: 3.92307,
    y1: 64.2308,
    x2: 742.154,
    y2: 64.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_2",
    x1: 30.7308,
    y1: 63.8889,
    x2: 646.115,
    y2: 63.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_2",
    x1: -3.6154,
    y1: 77.011,
    x2: 735.077,
    y2: 77.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_2",
    x1: 10.7778,
    y1: 211.989,
    x2: 722.111,
    y2: 211.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_2",
    x1: 3.15384,
    y1: 175.593,
    x2: 741.385,
    y2: 175.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_2",
    x1: 15.8421,
    y1: 156,
    x2: 689.526,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_2",
    x1: 24.1053,
    y1: 174,
    x2: 697.789,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_2",
    x1: -55.3158,
    y1: 174,
    x2: 786.789,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4_2",
    x1: -6.71876,
    y1: 215,
    x2: 743.281,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_2",
    x1: 17.9687,
    y1: 212,
    x2: 717.969,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4_2",
    x1: -15,
    y1: 207.5,
    x2: 785,
    y2: 207.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4_2",
    x1: 17.0625,
    y1: 78,
    x2: 717.063,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4_2",
    x1: 15.0625,
    y1: 41,
    x2: 715.063,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4_2",
    x1: 11.375,
    y1: 95.5,
    x2: 711.375,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4_2",
    x1: 8,
    y1: 65,
    x2: 708,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4_2",
    x1: -1.6875,
    y1: 63.5,
    x2: 748.313,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4_2",
    x1: 7.33334,
    y1: 176,
    x2: 718.444,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4_2",
    x1: 8.8889,
    y1: 177,
    x2: 720,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4_2",
    x1: 12.907,
    y1: 173.5,
    x2: 719.884,
    y2: 173.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4_2",
    x1: -3.11627,
    y1: 173.5,
    x2: 741.07,
    y2: 173.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4_2",
    x1: 6.66164,
    y1: 156,
    x2: 721.638,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutDesignVector);
export default __webpack_public_path__ + "static/media/about-design-vector.13e86041d016ec261f8f2a04b3791104.svg";
export { ForwardRef as ReactComponent };